<template>
    <div>
        <div    @click=""
                class="flex flex-row items-center justify-between w-full">
            <div class="bg-white overflow-hidden shadow rounded-lg py-1 px-2 md:p-0">

                <a      :href="alarmsLink('threshold')"
                        class="plain-link">
                    <div class="p-2 md:p-4">
                        <div class="flex flex-row items-center my-1 mr-8">
                            <span class="bg-blue-500 p-3 rounded-md">
                                <span class="lnr icon-coolant-temperature text-white">
                                </span>
                            </span>
                            <div class="pl-3 flex flex-col items-begin">
                                <span class="hidden md:block text-base font-normal text-gray-900">
                                    Threshold <span class="hidden xl:inline">Alarms</span>
                                </span>
                                <span class="text-2xl font-semibold text-blue-600">
                                    {{ numberThreshold }}
                                    <span v-if="numberThresholdSnoozed > 0"
                                            class="hidden md:inline text-sm leading-5 font-medium text-gray-500">
                                        +{{ numberThresholdSnoozed }} snoozed
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>

            <div class="bg-white overflow-hidden shadow rounded-lg py-1 px-2 md:px-0 md:my-0">
                <a      :href="alarmsLink('offline')"
                        class="plain-link">
                    <div class="p-2 md:p-4">
                        <!-- Content goes here -->
                        <div class="flex flex-row items-center my-1 mr-16">
                            <span class="bg-blue-500 p-3 rounded-md">
                                <span class="lnr icon-cloud-crossed text-white"></span>
                            </span>
                            <div class="pl-3 flex flex-col items-begin">
                                <span class="hidden md:block text-base font-normal">
                                    Offline <span class="hidden xl:inline">Alarms</span>
                                </span>
                                <span class="text-2xl font-semibold text-blue-600">
                                    {{ numberOffline }}
                                    <span   v-if="numberOfflineSnoozed > 0"
                                            class="hidden md:inline text-sm leading-5 font-medium text-gray-500">
                                        +{{ numberOfflineSnoozed }} snoozed
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>

            <!-- Empty div for display -->
            <div class="hidden md:block">

            </div>
        </div>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from "@/mixins/IconNamesMixin";
import axios from "axios";

export default {
    name: "AlarmStatus",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    props: {
        company: String,
    },
    data() {
        return {
            numberOffline: 0,
            numberOfflineSnoozed: 1,
            numberThreshold: 0,
            numberThresholdSnoozed: 1,
        }
    },
    created() {
    },
    mounted() {
        axios.get(this.company.buildCompanyApiInternalRoute(`dashboard/alarm-status-summary`)
        ).then(response => {
            this.numberOffline = response.data.offline.active
            this.numberOfflineSnoozed = response.data.offline.snoozed
            this.numberThreshold = response.data.threshold.active
            this.numberThresholdSnoozed = response.data.threshold.snoozed
        })
    },
    methods: {
        alarmsLink(alarmType) {
            let url = `/${this.company}/alarms?`
            url += alarmType === 'threshold' ? 'showThreshold=true&showOffline=false' : 'showThreshold=false&showOffline=true'
            return url;
        },
    },
    computed: {},
    beforeUnmount() {
    },
}

</script>


